import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Product } from "../model/Config";

interface CenikSectionProps {
  steaks: Product[];
  entrails: Product[];
}

const PriceCard: React.FC<{ item: Product }> = ({ item }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      px: 2.5,
      py: 1.5,
      borderRadius: "6px",
      background: "rgba(255,255,255,0.06)",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
      transition: "background 0.15s",
      "&:hover": { background: "rgba(255,255,255,0.12)" },
    }}
  >
    <Typography sx={{ color: "#e8dcc8", fontSize: "15px", fontWeight: 400 }}>
      {item.name}
    </Typography>
    <Typography
      sx={{
        color: "#c8b87a",
        fontSize: "15px",
        fontWeight: 700,
        ml: 2,
        whiteSpace: "nowrap",
      }}
    >
      {item.price} Kč
    </Typography>
  </Box>
);

const CenikSection: React.FC<CenikSectionProps> = ({ steaks, entrails }) => {
  return (
    <Box id="cenik" sx={{ background: "#f5f0e5" }}>
    <Box sx={{ py: { xs: 6, md: 10 }, px: { xs: 2, md: 6 }, maxWidth: "950px", mx: "auto" }}>
      {/* Header */}
      <Typography
        sx={{ fontSize: "13px", letterSpacing: "4px", color: "#a89858", textTransform: "uppercase", mb: 1 }}
      >
        Ceník masa
      </Typography>
      <Typography variant="h4" component="h2" sx={{ color: "#2d2a22", fontWeight: 700, mb: 1 }}>
        Bio hovězí maso
      </Typography>
      <Typography sx={{ color: "#7a6a55", mb: 5, fontSize: "15px" }}>
        Blonde d'Aquitaine · kontrolovaný BIO chov
      </Typography>

      {/* Mixed package highlight */}
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 2,
          mb: 5,
          px: 3,
          py: 2,
          background: "#2d2a22",
          borderRadius: "8px",
          border: "1px solid #c8b87a44",
        }}
      >
        <Box>
          <Typography sx={{ color: "#c8b87a", fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase", mb: 0.3 }}>
            Směsný balíček
          </Typography>
          <Typography sx={{ color: "#f5edd8", fontSize: "17px", fontWeight: 700 }}>
            10 kg hovězího masa
          </Typography>
        </Box>
        <Box sx={{ width: "1px", height: "40px", background: "#c8b87a44" }} />
        <Typography sx={{ color: "#c8b87a", fontSize: "24px", fontWeight: 700 }}>
          2 700 Kč
        </Typography>
      </Box>

      {/* Two columns */}
      <Grid container spacing={3} alignItems="stretch">
        {/* Steaky */}
        <Grid item xs={6} sx={{ "@media (max-width: 550px)": { flexBasis: "100%", maxWidth: "100%" } }}>
          <Box
            sx={{
              background: "#2d2a22",
              borderRadius: "12px",
              overflow: "hidden",
              height: "100%",
            }}
          >
            <Box sx={{ px: 3, py: 2.5, borderBottom: "1px solid rgba(200,184,122,0.2)", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
              <Box>
                <Typography
                  sx={{ color: "#c8b87a", fontSize: "11px", letterSpacing: "4px", textTransform: "uppercase", mb: 0.5 }}
                >
                  Kategorie
                </Typography>
                <Typography variant="h5" component="h3" sx={{ color: "#f5edd8", fontWeight: 700 }}>
                  Steaky
                </Typography>
              </Box>
              <Typography sx={{ color: "#b0a080", fontSize: "13px", letterSpacing: "1px" }}>
                cena za 1 kg
              </Typography>
            </Box>
            <Box sx={{ p: 1.5, display: "flex", flexDirection: "column", gap: 0.5 }}>
              {steaks.map((item) => (
                <PriceCard key={item.name} item={item} />
              ))}
            </Box>
          </Box>
        </Grid>

        {/* Vnitřnosti */}
        <Grid item xs={6} sx={{ "@media (max-width: 550px)": { flexBasis: "100%", maxWidth: "100%" } }}>
          <Box
            sx={{
              background: "#2d2a22",
              borderRadius: "12px",
              overflow: "hidden",
              height: "100%",
            }}
          >
            <Box sx={{ px: 3, py: 2.5, borderBottom: "1px solid rgba(200,184,122,0.2)", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
              <Box>
                <Typography
                  sx={{ color: "#c8b87a", fontSize: "11px", letterSpacing: "4px", textTransform: "uppercase", mb: 0.5 }}
                >
                  Kategorie
                </Typography>
                <Typography variant="h5" component="h3" sx={{ color: "#f5edd8", fontWeight: 700 }}>
                  Maso, vnitřnosti
                </Typography>
              </Box>
              <Typography sx={{ color: "#b0a080", fontSize: "13px", letterSpacing: "1px" }}>
                cena za 1 kg
              </Typography>
            </Box>
            <Box sx={{ p: 1.5, display: "flex", flexDirection: "column", gap: 0.5 }}>
              {entrails.map((item) => (
                <PriceCard key={item.name} item={item} />
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
    </Box>
  );
};

export default CenikSection;
